"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@coreui/react");
const react_2 = require("react");
const portal_api_1 = require("portal-api");
const utils_1 = require("utils");
function LocationFeatures({ location, isDisabled, hasPermDigitalReceipt, hasPermOta, }) {
    const [modalVisible, setModalVisible] = (0, react_2.useState)(false);
    const [loading, setLoading] = (0, react_2.useState)(false);
    const [actionType, setActionType] = (0, react_2.useState)('on');
    const [currentFeature, setCurrentFeature] = (0, react_2.useState)('');
    const [featureStates, setFeatureStates] = (0, react_2.useState)({});
    const isFeatureDisabled = (feature) => {
        if (isDisabled)
            return true;
        if (feature === 'digitalReceiptsEnabled' && !hasPermDigitalReceipt)
            return true;
        if (feature === 'pushApplicationEnabled' && !hasPermOta)
            return true;
        return false;
    };
    const FEATURE_TO_LABEL = {
        pushApplicationEnabled: 'OTA',
        digitalReceiptsEnabled: 'Digital Receipts',
    };
    const FEATURE_TO_API_NAME = {
        pushApplicationEnabled: 'ota',
        digitalReceiptsEnabled: 'digital_receipts',
    };
    const [enableFeature] = (0, portal_api_1.usePostInternalPortalV1LocationsLocationIdFeaturesFeatureNameEnableMutation)();
    const [disableFeature] = (0, portal_api_1.usePatchInternalPortalV1LocationsLocationIdFeaturesFeatureNameDisableMutation)();
    const handleSwitchChange = (feature, newValue) => {
        setCurrentFeature(feature);
        setActionType(newValue ? 'on' : 'off');
        setModalVisible(true);
    };
    const handleModalAccept = async () => {
        setLoading(true);
        const isActivating = actionType === 'on';
        const apiFeatureName = FEATURE_TO_API_NAME[currentFeature];
        try {
            const result = isActivating
                ? await enableFeature({
                    locationId: location.locationId,
                    featureName: apiFeatureName,
                })
                : await disableFeature({
                    locationId: location.locationId,
                    featureName: apiFeatureName,
                });
            if (!('error' in result)) {
                setFeatureStates((prev) => ({
                    ...prev,
                    [currentFeature]: isActivating,
                }));
            }
            setModalVisible(false);
        }
        catch (error) {
            // Close modal on exception since we already handle that with pop-up message
            setModalVisible(false);
        }
        finally {
            setLoading(false);
        }
    };
    const handleModalCancel = () => {
        setModalVisible(false);
    };
    const featureLabel = currentFeature
        ? FEATURE_TO_LABEL[currentFeature]
        : '';
    const modalTitle = `Turn ${actionType} ${featureLabel}`;
    const modalMessage = `Are you sure you want to turn ${actionType} ${featureLabel} for location ID ${location.locationId}?`;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { children: Object.entries(FEATURE_TO_LABEL).map(([feature, label]) => ((0, jsx_runtime_1.jsx)("div", { className: "location-features", children: (0, jsx_runtime_1.jsxs)("div", { className: "location-feature", children: [(0, jsx_runtime_1.jsx)("span", { className: "lender-name", children: (0, utils_1.titleCase)(label) }), (0, jsx_runtime_1.jsx)(react_1.CFormSwitch, { className: "toggle-button", disabled: isFeatureDisabled(feature), checked: featureStates[feature] !== undefined
                                    ? featureStates[feature]
                                    : !!location[feature], onChange: (e) => handleSwitchChange(feature, e.target.checked) })] }) }, feature))) }), (0, jsx_runtime_1.jsxs)(react_1.CModal, { visible: modalVisible, onClose: handleModalCancel, portal: false, children: [(0, jsx_runtime_1.jsxs)(react_1.CModalHeader, { children: ["Confirm ", modalTitle] }), (0, jsx_runtime_1.jsx)(react_1.CModalBody, { children: modalMessage }), (0, jsx_runtime_1.jsxs)(react_1.CModalFooter, { children: [(0, jsx_runtime_1.jsx)(react_1.CButton, { color: "secondary", onClick: handleModalCancel, children: "Cancel" }), (0, jsx_runtime_1.jsxs)(react_1.CButton, { color: "primary", onClick: handleModalAccept, disabled: loading, children: ["Accept ", loading && (0, jsx_runtime_1.jsx)(react_1.CSpinner, { size: "sm" })] })] })] })] }));
}
exports.default = LocationFeatures;
